<template>
    <section :id="slice.primary.anchorName || undefined" class="slice slice-plans" aria-label="plans">
        <div class="slice-content">
            <div class="plans-panel">
                <PrismicRichText v-if="slice.primary.title" :field="slice.primary.title" class="slice-title" />

                <div class="slice-body">
                    <div v-for="(item, i) in slice.items" :key="i" :item="item" class="plan">
                        <div class="plan-image">
                            <PrismicImage :image="item.image" />
                        </div>
                        <div class="plan-title">{{ item.title }}</div>
                        <PrismicRichText :field="item.text" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {PlansSlice} from '@prismicio-types';
    import PrismicImage from '~/components/PrismicImage.vue';

    defineProps(getSliceComponentProps<PlansSlice>(['slice', 'index', 'slices', 'context']));
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-plans {
        .slice-body {
            text-align: left;
            @include mq.screen_sm(min) {
                display: flex;
                gap: var(--joy-core-spacing-8);
            }
        }
        .plans-panel {
            border-radius: var(--joy-core-radius-4);
            background-color: var(--joy-color-secondary-10);
            padding: var(--joy-core-spacing-8) var(--joy-core-spacing-5);
            @include mq.screen_md(min) {
                padding: var(--joy-core-spacing-12);
            }
        }
        .plan {
            margin: var(--joy-core-spacing-4) auto 0;
            @include mq.screen_xs(min) {
                max-width: 450px;
            }
            @include mq.screen_md(min) {
                width: 25%;
            }
            &-image {
                width: 40px;
                margin-bottom: var(--joy-core-spacing-2);
                > img {
                    width: 100%;
                }
            }
            &-title {
                font-size: var(--joy-font-size-primary-600);
                font-weight: var(--joy-font-weight-bold);
                margin-bottom: var(--joy-core-spacing-4);
                @include mq.screen_lg(min) {
                    font-size: var(--joy-font-size-primary-800);
                }
            }
        }
    }
</style>
